import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLegacyRedirectPath } from "../../utils/legacyUrlRedirects";

/** Client-side redirect for retired legacy paths (complements .htaccess on Hostinger). */
export default function LegacyUrlRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = getLegacyRedirectPath(pathname);
    if (target && target !== pathname) {
      navigate(`${target}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
}
